<template>
  <div>
    <Preloader v-if="isLoading" />
    <Filters
      v-show="isShowBulkDownload"
      textButtonSubmit="Download"
      :data="filters"
      withGroups
      :isLoading="isLoading"
      @submit="downloadArchive($event, false)"
    />
  </div>
</template>

<script>
import Moment from 'moment'
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import Preloader from '@components/Preloader'
import Filters from '@components/Filter/Filter'

export default {
  name: 'BulkDownloadInvoices',
  components: {
    Preloader,
    Filters
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const defaultDateFormat = 'YYYY-MM-DD'
    return {
      isLoading: false,
      defaultDateFormat,
      dateFrom: Moment().subtract(1, 'months').startOf('month').format(defaultDateFormat),
      dateTo: Moment().subtract(1, 'months').endOf('month').format(defaultDateFormat),
      ownBankDetail: null,
      invoiceTemplateType: null,
      payoutTemplateType: null,

      filters: {
        groups: {
          'filters': {
            name: 'Filters:',
            fields: {
              'date_from': {
                type: 'datepicker',
                name: 'date_from',
                label: 'Date from',
                validation: [
                  { name: 'required' }
                ],
                value: Moment().subtract(1, 'months').startOf('month').format(defaultDateFormat),
                format: 'yyyy-MM-dd',
                class: 'col-md-2',
                group: 'filters'
              },
              'date_to': {
                type: 'datepicker',
                name: 'date_to',
                label: 'Date to',
                validation: [
                  { name: 'required' }
                ],
                value: Moment().subtract(1, 'months').endOf('month').format(defaultDateFormat),
                format: 'yyyy-MM-dd',
                class: 'col-md-2',
                group: 'filters'
              },
              'bank_details': {
                type: 'multiselect',
                name: 'own_bank_details',
                label: 'Own bank detail',
                valueField: 'id',
                selectLabel: 'name',
                placeholder: 'Any',
                options: [],
                value: [],
                class: 'col-md-4',
                group: 'filters'
              }
            }
          },
          'templates': {
            name: 'Documents templates:',
            fields: {
              'payout_template_type': {
                type: 'select',
                name: 'payout_template_type',
                label: 'Payout template type',
                valueField: 'id',
                selectLabel: 'name',
                placeholder: 'Saved in payout',
                options: [],
                value: null,
                class: 'col-md-3',
                group: 'templates'
              },
              'invoice_template_type': {
                type: 'select',
                name: 'invoice_template_type',
                label: 'Invoice template type',
                valueField: 'id',
                selectLabel: 'name',
                placeholder: 'Saved in invoice',
                options: [],
                value: null,
                class: 'col-md-3',
                group: 'templates'
              },
              'expense_template_type': {
                type: 'select',
                name: 'expense_template_type',
                label: 'Expense template type',
                placeholder: 'Saved in expense',
                options: [],
                value: null,
                disabled: true,
                class: 'col-md-3',
                group: 'templates'
              }
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      getOwnBankDetails: 'finances/getOwnBankDetails',
      getPayoutsTemplateTypes: 'finances/getPayoutsTemplateTypes',
      getTemplates: 'finances/getTemplates'
    }),
    payoutsTemplateTypes () {
      return this.getPayoutsTemplateTypes.filter(item => item.name !== 'custom')
    },
    invoicesTemplateTypes () {
      return this.getTemplates.filter(item => item.name !== 'custom')
    },

    isShowBulkDownload: {
      get () {
        return this.show
      },
      set (value) {
        this.$emit('update:show', value)
      }
    }
  },
  methods: {
    ...mapActions({
      setIsModalLoading: 'finances/setIsModalLoading'
    }),
    Moment: function (date) {
      return Moment(date)
    },
    toggleShowBulkDownload () {
      this.isShowBulkCreation = !this.isShowBulkCreation
    },
    async downloadArchive (fields, downloadWithEmpty) {
      this.isLoading = true

      const params = {
        date_from: fields.date_from ? this._toLocalTime(fields.date_from.value, this.defaultDateFormat) : null,
        date_to: fields.date_to ? this._toLocalTime(fields.date_to.value, this.defaultDateFormat) : null,
        download_with_empty: downloadWithEmpty
      }

      if (fields.bank_details && fields.bank_details.value) {
        params['own_bank_details_ids'] = fields.bank_details.value.map(bankDetail => bankDetail.id)
      }
      if (fields.payout_template_type && fields.payout_template_type.value) {
        params['payout_template_type_id'] = fields.payout_template_type.value.id
      }
      if (fields.invoice_template_type && fields.invoice_template_type.value) {
        params['invoice_template_type_id'] = fields.invoice_template_type.value.id
      }
      return axios
        .post(`/api/finances/reports/download-in-out-invoices`, params, {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          async (response) => {
            if (response.status === 204) {
              this.$snotify.info(
                'No data for selected parameters',
                'Info',
                this.$store.state.snotify
              )
              return
            }
            const fileName = response.headers['content-disposition'].split('filename=').pop()

            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }))
            const link = document.createElement('a')
            link.href = url
            link.target = '_blank'
            link.setAttribute('download', fileName)
            document.body.appendChild(link)
            link.click()

            document.body.removeChild(link)
            URL.revokeObjectURL(url)
          },
          async (error) => {
            if (error.response.status === 424) {
              const data = JSON.parse(await error.response.data.text())

              const confirm = await this.$root.$confirm.open(
                'Expenses without attachments',
                data.message,
                { submitText: 'Download anyway' }
              )
              if (confirm) {
                await this.downloadArchive(fields, true)
              }
            }
          }
        ).finally(() => {
          this.isLoading = false
        })
    }
  },
  created () {
    return Promise.all([
      this.$api.finances.getBankDetailsAll(),
      this.$api.finances.getPayoutsTemplateTypes(),
      this.$api.finances.getInvoicesTemplate()
    ]).then(() => {
      this.filters.groups.filters.fields.bank_details.options = this.getOwnBankDetails
      this.filters.groups.templates.fields.payout_template_type.options = this.payoutsTemplateTypes
      this.filters.groups.templates.fields.payout_template_type.value = this.payoutsTemplateTypes.find(item => item.id === null)
      this.filters.groups.templates.fields.invoice_template_type.options = this.invoicesTemplateTypes
      this.filters.groups.templates.fields.invoice_template_type.value = this.invoicesTemplateTypes.find(item => item.id === null)
    })
  }
}
</script>

<style lang="scss">
  .bulk-download-panel {
    padding: 20px;
    background: #E4E7EE;
    border-radius: 10px;
    margin-bottom: 30px;
  }
</style>
